<div class="w-full">
  <div
    class="flex items-center justify-between cursor-pointer mb-3 pb-3 border-b border-blue-light"
    role="button"
    tabindex="0"
    (click)="toggle()"
    (keydown.enter)="toggle()"
    (keydown.space)="toggle()"
  >
    <h6 class="text-xs font-semibold text-blue-300 m-0">
      {{ title }}
    </h6>
    <i
      class="pi pi-chevron-down text-blue-deep text-xs transition-transform duration-200"
      [class.rotate-180]="isExpanded"
    ></i>
  </div>
  <div
    class="overflow-hidden max-h-0 transition-all duration-300"
    [class.max-h-expanded]="isExpanded"
  >
    @if (isExpanded) {
      <div class="flex flex-col items-start gap-2">
        <ng-content></ng-content>
      </div>
    }
  </div>
</div>
